import { render, staticRenderFns } from "./LatestProjects.vue?vue&type=template&id=7c155f5b&scoped=true"
import script from "./LatestProjects.vue?vue&type=script&lang=js"
export * from "./LatestProjects.vue?vue&type=script&lang=js"
import style0 from "./LatestProjects.vue?vue&type=style&index=0&id=7c155f5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c155f5b",
  null
  
)

export default component.exports